import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {IonContent, NavParams} from '@ionic/angular';

import {AuthenticationService} from 'src/app/services/authentication/authentication.service';
import {SuccessMessageService} from 'src/app/services/message-provider/success-message.service';
import {UniqueIDService} from 'src/app/services/unique-id/unique-id.service';
import {Navigator} from 'src/app/services/routing/navigator';
import {LogoutService} from 'src/app/services/logout/logout.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
  selector: 'reset-password-mfa',
  templateUrl: './reset-password-mfa-email.component.html',
  styleUrls: ['./reset-password-mfa-email.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class ResetPasswordMFAEmailComponent implements OnInit {
  @ViewChild(IonContent, {static: false}) content: IonContent;

  error = null;
  tokenExpired = false;
  verifiedCode: boolean;
  showMessageSMSSent: boolean;
  // customer: CustomerModel;
  channels: string[];
  phoneNumber = "stubValue";
  currentDisplayChannel: string;
  bypassPinSuccessUI = false; // it is by design in some case
  tokenURL;
  customerId;
  token: string = null;
  email: any;
  
  constructor(
    private navParams: NavParams,
    private authenticationService: AuthenticationService,
    private uniqueIDService: UniqueIDService,
    private navigator: Navigator,
    private logoutService: LogoutService,
    private configService: ConfigService,
    public successMessageService: SuccessMessageService,
    public utils: UtilsService,
    private cgd:ChangeDetectorRef
  ) {
    this.email = this.navParams.get('email').email;

    const mfaType = this.configService.getConfig().FEATURE_MFA_TYPE;
    const channels = this.configService.getConfig().FEATURE_MFA_CHANNELS as string;
    if(channels) {
      this.channels = channels.replace(/\s/g, '').split(','); //clean spaces in case configuration is not clean
    }
    if(!this.channels || this.channels.length == 0) {
      this.channels = ['SMS']; // default
    }

    if(mfaType && !this.channels.includes(mfaType)) {
      this.channels.push(mfaType);
    }
    this.currentDisplayChannel = mfaType ? mfaType : this.channels?.[0];
  }

  ngOnInit() {
    this.uniqueIDService.removeMFADeviceId();
    
  }

  onValidateToken(token){
    this.authenticationService.callValidateTokenMFAEmail({token: token, email: this.email.email }).subscribe(
        (response: any) => {
            if (response && !!response.result) {
                this.error = null;
                this.content.scrollToTop();
                this.customerId = response.payload.customer_id;
                this.cgd.detectChanges();
                this.navigator.navigateTo("ResetPasswordMFASecondStepComponent",{},{"token": token, "customerId": this.customerId, "email": this.email.email});
            }
        },
        (error) => {
            switch (error.getErrorCode().toUpperCase()) {
                case 'INVALID_TOKEN':
                    error.setErrorMessage('The token provided is invalid');
                    break;
                case "TOKEN_EXPIRED":
                    error.setErrorMessage('The token provided is expired');
                    break;
                case "NOT_VALID_TOKEN":
                    error.setErrorMessage('The token provided is expired');
                    break;
                default:
                  error.setErrorMessage('Something went wrong.');
                  break;

            }
            this.error = error;
            // this.tokenExpired = true;
            this.content.scrollToTop(10);
            this.cgd.detectChanges();
        }
    );
}

  closeModal = () => {
      this.navigator.dismiss();
      return this.logoutService.onLogout();
  };

  onValidatePinError(event) {
    this.error = event;
    console.log(this.error);
    
    if (this.error) {
      this.content.scrollToTop(10);
    }
  }

  validatePinError(){
    console.log("validate error");
  }
}
